import { render } from "./CenterLayout.vue?vue&type=template&id=3ae99be4&scoped=true&ts=true"
import script from "./CenterLayout.vue?vue&type=script&lang=ts"
export * from "./CenterLayout.vue?vue&type=script&lang=ts"

import "./CenterLayout.vue?vue&type=style&index=0&id=3ae99be4&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae99be4"]])

export default __exports__